
import request from '@/utils/request';

// 获取验证图片 及token
export function reqGet(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_URL}/captcha/get`,
    method: 'post',
    data
  });
}

// 滑动或者点选验证
export function reqCheck(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_URL}/captcha/check`,
    method: 'post',
    data
  });
}

